module.exports = __webpack_public_path__ + "img/menu-mobile.1acc49d4.svg";